<template>
    <div>
        <div class="label" v-if="label" >{{label}}</div>
        <div class="content_wrap">
            <input :type="pType" class="input_contents" :placeholder="placeholderStr" :value="value" v-model="model" ref="inputEl" @keyup="keyup($event)" :style="styles"  @click="click($event)" :readonly="isReadOnly">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FormInput",
        props : {
            label : {
                type : String,
                default : '',
            },
            clickInput : {
                type : Function,
                default : () => {}
            },
            placeholderStr : {
                type : String,
                default : ''
            },
            value : {
                type : String,
                default : '',
            },
            type : {
                type : String,
                default : 'text'
            },
            isReadOnly : {
                type : Boolean,
                default : false
            },
            pWidth : {
                type : String,
                default : '',
            }
        },
        data(){
            return {
                pType : '',
                styles : {},
            }
        },
        methods : {
            click(e){
                if(this.type === 'number') e.currentTarget.select();
                this.clickInput(e);
            },
            keyup(e){
                if(this.type === 'number'){
                    const target = e.currentTarget;
                    const rgx1 = /\D/g;
                    const rgx2 = /(\d+)(\d{3})/;
                    let num = target.value.replace(rgx1,"");

                    while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');
                    this.$emit("input", "" + num);
                }
            }
        },
        computed: {
            model: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        },
        mounted(){
            if(this.type === 'phone') this.$Util.setPhoneFormatter(this.$refs.inputEl);
        },
        created(){
            if(this.type === 'phone') {
                this.pType = 'tel';
            }else if(this.type === 'number'){
                this.pType = 'tel';
                this.styles.textAlign = 'right';
            }else {
                this.pType = this.type;
            }

            if(this.pWidth !== '') {
                this.styles.width = this.pWidth;
                this.styles.flex = 'unset';
            }
        }
    }
</script>

<style scoped>
    .label {font-size:15px; font-weight:800; color:#505050;}
    .content_wrap{margin-top:5px; display:flex;}
    .input_contents{padding: 10px;width:100%;border-radius:5px; border:1px solid #eaeaea; flex:1; font-size:15px;}
</style>